function setInboundTransmissions(state, transmissions) {
	state.inboundTransmissions = transmissions;
}

function setOutboundTransmissions(state, transmissions) {
	state.outboundTransmissions = transmissions;
}
export default { setInboundTransmissions, setOutboundTransmissions };